/** @format */

import { useState, useCallback } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTrigger } from "react-bootstrap";

import { ReactComponent as Share } from "bootstrap-icons/icons/share.svg";
import { ReactComponent as Email } from "bootstrap-icons/icons/envelope-open.svg";
// import { ReactComponent as Twitter } from 'bootstrap-icons/icons/twitter.svg';
// import { ReactComponent as Facebook } from '../../assets/icons/facebook.svg';
import { ReactComponent as Files } from "bootstrap-icons/icons/files.svg";

import { useTranslation } from "react-i18next";

import "./SharePopup.scss";

import {
  // FacebookShareButton,
  // TwitterShareButton,
  EmailShareButton,
} from "react-share";

import { UserResource } from "../../types";

type Props = {
  resourceLink: string;
  userResource?: UserResource;
};

const SharePopup: React.FC<Props> = ({ resourceLink, userResource }) => {
  const [showShareOptions, setShowShareOptions] = useState(false);
  const { t: _ } = useTranslation();

  const handleCloseShareOptions = () => setShowShareOptions(false);
  const handleShowShareOptions = useCallback(() => {
    if (userResource && userResource.Status === "live")
      setShowShareOptions(true);
  }, [userResource]);

  const tooltip = (
    <Tooltip id="tooltip" className="copy-text-tooltip" role="tooltip">
      {_("Copied to clipboard.")}
    </Tooltip>
  );

  const [showTooltip, setShowTooltip] = useState(false);

  const handleToggleShow = useCallback((showTooltip: boolean) => {
    setShowTooltip(showTooltip);
    if (showTooltip === true) {
      setTimeout(() => setShowTooltip(false), 1500);
    }
  }, []);

  return (
    <div className="share-popup">
      <Button
        className="share-button action"
        onClick={handleShowShareOptions}
        title="Share resource"
        disabled={userResource && userResource.Status !== "live"}
      >
        <Share className="icon" />
      </Button>
      <div className="share-popup-container">
        <Modal
          show={showShareOptions}
          onHide={handleCloseShareOptions}
          className="share-popup"
          title="Share modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{_("Share your resource with students")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="py-2 d-flex align-items-center share-icons resource-actions">
              <div className="share-icon-container">
                <EmailShareButton
                  url={resourceLink}
                  subject={_("Check this resource out!")}
                  style={{}}
                  className="share-icon action"
                  title={_("Share via email")}
                >
                  <Email className="icon" />
                </EmailShareButton>
              </div>
              {/* <div className="share-icon-container" title="Share on Twitter">
                    <TwitterShareButton
                      url={resourceLink}
                      title={_('Share on Twitter')}
                      className="share-icon action"
                      style={{}}
                    >
                      <Twitter className="icon" />
                    </TwitterShareButton>
                  </div>
                  <div
                    className="share-icon-container"
                    title={_('Share on Facebook')}
                  >
                    <FacebookShareButton
                      url={resourceLink}
                      quote={_('Check this resource out!')}
                      hashtag="#wjecresources"
                      className="share-icon action"
                      style={{}}
                    >
                      <Facebook className="icon" />
                    </FacebookShareButton>
                  </div> */}
            </div>
            <p>{_("Page link")}</p>
            <div className="link-container" title={_("Copy to clipboard")}>
              <OverlayTrigger
                placement="bottom"
                overlay={tooltip}
                trigger="click"
                show={showTooltip}
                onToggle={handleToggleShow}
              >
                <button
                  className="copy-button gap-2"
                  title="Copy button"
                  onClick={() => {
                    if (
                      window.isSecureContext &&
                      navigator.clipboard &&
                      resourceLink
                    ) {
                      navigator.clipboard.writeText(resourceLink);
                    } else {
                      alert(_("Not able to copy to clipboard"));
                    }
                  }}
                >
                  <p>{resourceLink}</p>
                  <Files fill="#2D3538" className="copy-icon flex-shrink-0" />
                </button>
              </OverlayTrigger>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              title="Close modal button"
              onClick={handleCloseShareOptions}
            >
              {_("Close")}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default SharePopup;
